import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DiaMixin extends Vue {
  public habilitarUltimoDiaMes(ymd: string, date: Date): boolean {
    const dia = date.getDate();
    const mes = date.getMonth();
    const anio = date.getFullYear();
    const ultimoDiaMes = new Date(anio, mes + 1, 0).getDate();
    return dia !== ultimoDiaMes;
  }

  public validarFechaUltimoDiaMes(fecha: string): boolean {
    const [anio, mes, dia] = fecha.split('-').map(Number);
    const ultimoDiaMes = new Date(anio, mes, 0).getDate();
    return dia === ultimoDiaMes;
  }

  public habilitarPrimerDiaMes(ymd: string, date: Date): boolean {
    const dia = date.getDate();
    return dia !== 1;
  }

  /**
   * Método para habilitar la fecha de inicio del movimiento periódico
   * y restringir que solo se pueda seleccionar una fecha despúes de
   * la fecha de inicio de beca.
   * @param fechaInicio la fecha de inicio.
   * @returns validación de la fecha de inicio.
   */
  public habilitarFechaInicioMovPeriodico(ymd: string, date: Date, fechaInicio: string): boolean {
    const dia = date.getDate();

    if (fechaInicio) {
      const [anioInicio, mesInicio, diaInicio] = fechaInicio.split('-').map(Number);
      const minDate = new Date(anioInicio, mesInicio - 1, diaInicio);
      return dia !== 1 || date < minDate;
    } else {
      return dia !== 1;
    }
  }

  /**
   * Método para habilitar la fecha de fin del movimiento periódico
   * y restringir que solo se pueda seleccionar una fecha antes de
   * la fecha fin de beca.
   * @param fechaFin la fecha de fin.
   * @returns validación de la fecha de fin.
   */
  public habilitarFechaFinMovPeriodico(ymd: string, date: Date, fechaFin: string): boolean {
    const dia = date.getDate();
    const mes = date.getMonth();
    const anio = date.getFullYear();
    const ultimoDiaMes = new Date(anio, mes + 1, 0).getDate();

    if (fechaFin) {
      const [anioFin, mesFin, diaFin] = fechaFin.split('-').map(Number);
      const maxDate = new Date(anioFin, mesFin - 1, diaFin);
      return dia !== ultimoDiaMes || date > maxDate;
    } else {
      return dia !== ultimoDiaMes;
    }
  }
}
